import { render, staticRenderFns } from "./EocViewAddEditDiagnosisCodesModal.vue?vue&type=template&id=2cd70231&"
import script from "./EocViewAddEditDiagnosisCodesModal.vue?vue&type=script&lang=js&"
export * from "./EocViewAddEditDiagnosisCodesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports